<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_10"></a><a id="page_11"></a><a id="halftitle1"></a><span class="border">   ORPHANS <em>of</em>   </span><br/><span class="dropcap">Chaos</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?7a7ce001